// AddressAutocompleteField.jsx
import React from 'react';
import AddressAutocompleteInput from './AddressAutocompleteInput';
import { getFieldLabel } from '../utils/formHelpers';

const AddressAutocompleteField = ({ field, data, change, hasError, errorMessage }) => {
    return (
        <AddressAutocompleteInput
            label={getFieldLabel(field)}
            placeholder={field.placeholder}
            value={data[field.key] || ''}
            onChange={(next) => change(field.key, next)}
            error={hasError}
            errorMessage={errorMessage}
            required={field.required}
        />
    );
};

export default AddressAutocompleteField;